import DefaultElementNodeType from '../DefaultElementNodeType';
import {STRATEGY_COURSE_OF_ACTION} from '../../metamodel/Concept';

export default class CourseOfActionNodeType extends DefaultElementNodeType {
	static get typeName() {
		return STRATEGY_COURSE_OF_ACTION;
	}
}
